import {AchievementLoading, IInternalState} from "./context";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IAchievement, IAchievementDetails} from "../../models/achievement/response";
import {IAchievementQuery} from "../../models/achievement/query";
import paramsReducer, {QueryAction} from "../base/base-reducer";
import toggleLoading from "../../utils/helpers/xor";

type Action =
    | {
    type: "LOADING";
    payload: { loading: AchievementLoading | AchievementLoading[] };
}
    | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IAchievement> } }
    | { type: "SET_DETAILS"; payload: { details?: IAchievementDetails } }
    | QueryAction<IAchievementQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
    switch (action.type){
        case "LOADING": {
            return {
                ...state,
                loading: toggleLoading(state.loading, action.payload.loading),
            };
        }
        case "SET_LIST": {
            return {
                ...state,
                list: action.payload.list,
            };
        }
        case "SET_DETAILS": {
            return {
                ...state,
                details: action.payload.details,
            };
        }
        default: {
            return paramsReducer(state, action);
        }
    }
}

export default reducer;